export interface TextEditorFont {
  name: string;
  label: string;
  regular: boolean;
  bold: boolean;
  italic: boolean;
  boldItalic: boolean;
}
export type TextEditorOperation = 'bold' | 'italics' | 'underline' | 'strikethrough';

export interface TextEditorSelectedTextState {
  from: number;
  to: number;
}
export type ToolbarItem =
  | 'fonts'
  | 'b'
  | 'i'
  | 'attributes'
  | 'emoji'
  | 'undo'
  | 'redo'
  | 'links'
  | 'media';

export interface TemplateAttribute {
  label: string;
  key: string;
  group: string;
}

// Editor storage types for formatting state
export type FormattingState = {
  isBold?: boolean;
  isItalics?: boolean;
  fontName?: string;
};

export type EditorStorageWithFormatting<TStorage = Record<string, unknown>> = TStorage & {
  formattingState?: FormattingState;
};

export const TEMPLATE_ATTRIBUTES: TemplateAttribute[] = [
  {
    label: 'Title',
    key: 'title',
    group: 'People Attributes',
  },
  {
    label: 'First Name',
    key: 'first_name',
    group: 'People Attributes',
  },
  {
    label: 'Middle Name',
    key: 'mid_name',
    group: 'People Attributes',
  },
  {
    label: 'Last Name',
    key: 'last_name',
    group: 'People Attributes',
  },
  {
    label: 'Suffix',
    key: 'suffix',
    group: 'People Attributes',
  },
  {
    label: 'Address 1',
    key: 'address1',
    group: 'People Attributes',
  },
  {
    label: 'Address 2',
    key: 'address2',
    group: 'People Attributes',
  },
  {
    label: 'City',
    key: 'city',
    group: 'People Attributes',
  },
  {
    label: 'State',
    key: 'state',
    group: 'People Attributes',
  },
  {
    label: 'Zip',
    key: 'zip',
    group: 'People Attributes',
  },
  {
    label: 'Email',
    key: 'email',
    group: 'People Attributes',
  },
  {
    label: 'AUX Data 1',
    key: 'aux_data1',
    group: 'People Attributes',
  },
  {
    label: 'AUX Data 2',
    key: 'aux_data2',
    group: 'People Attributes',
  },
  {
    label: 'AUX Data 3',
    key: 'aux_data3',
    group: 'People Attributes',
  },
  {
    label: 'AUX Data 4',
    key: 'aux_data4',
    group: 'People Attributes',
  },
  {
    label: 'AUX Data 5',
    key: 'aux_data5',
    group: 'People Attributes',
  },
  {
    label: 'Agent First Name',
    key: 'agent_first_name',
    group: 'Agent Attributes',
  },
  {
    label: 'Agent Last Name',
    key: 'agent_last_name',
    group: 'Agent Attributes',
  },
  {
    label: 'Agent Full Name',
    key: 'agent_full_name',
    group: 'Agent Attributes',
  },
];
